import { useIsAdmin } from 'js/hooks/user';
import React, { Suspense, useMemo, useState } from 'react';
import { componentService } from 'js/services/component.service';

import * as helpers from './helpers';
import { PortletTitle } from './components/PortletTitle';
import { UnregisteredPortlet } from './components/UnregisteredPortlet';

export const Portlet = ({ portlet }) => {
    const isAdmin = useIsAdmin();
    const [showWrapper, setShowWrapper] = useState(true);
    const [wrapperClassNames, setWrapperClassNames] = useState([]);

    const { config, portletId, reactPortletId, portletType, title, column, look, customCSSClassName } = portlet;
    const portlets = componentService.getPageComponents();
    const isWrapperShown = showWrapper || isAdmin;
    const PortletComponent = portlets[portletType] || UnregisteredPortlet;
    const tkPrefix = helpers.getPortletTkPrefix(portletType);

    // as of react documentation this indeed sometimes produces new objects even if all dependencies are equal
    // delete this after removing usePortlet();
    const portletConfig = useMemo(
        () => ({ ...config, ...look, reactPortletId, portletId, portletType, tkPrefix }),
        [config, look, reactPortletId, portletId, portletType, tkPrefix]
    );

    const portletInfo = useMemo(
        () => ({ portletId, portletType, tkPrefix, look }),
        [look, portletId, portletType, tkPrefix]
    );

    const portletPreferences = useMemo(
        () => config,
        [config]
    );

    // id, data-portlet-id, data-react-portlet-id, data-portlet-column, data-portlet-type, data-portlet-title -
    // required for CMS
    return (
        <div
            id={`p_p_id_${portletId}`}
            data-portlet-title={title}
            data-portlet-id={portletId}
            data-portlet-column={column}
            data-portlet-type={portletType}
            data-react-portlet-id={reactPortletId}
            className={
                helpers.getPortletWrapperCSSClassNames(portletConfig, wrapperClassNames, isWrapperShown, customCSSClassName)
            }
        >
            {isWrapperShown && <PortletTitle portlet={portlet} />}
            <div className={helpers.getPortletCSSClassNames(portletConfig)}>
                <Suspense fallback="">
                    <PortletComponent
                        key={reactPortletId}
                        config={portletConfig}
                        portletInfo={portletInfo}
                        portletTkPrefix={tkPrefix}
                        setShowWrapper={setShowWrapper} // delete this
                        portletPreferences={portletPreferences}
                        setWrapperClassNames={setWrapperClassNames}
                    />
                </Suspense>
            </div>
        </div>
    );
};
